<template>
  <el-tree-select
    class="tree"
    lazy
    filterable
    remote
    teleported
    clearable
    :data="categoryLists"
    :expand-on-click-node="false"
    :load="load"
    accordion
    :remote-method="searchCategory"
    v-model="category_id"
    :props="treeSelectProps"
    @node-click="treeSelect"
    @clear="clear"
    :default-expanded-keys="defaultExpandedNodes"
    check-strictly
  />
</template>

<script setup>
import { categoryList } from '@/api/common.js'
import { nextTick, ref, unref, watch } from 'vue'

const emit = defineEmits(['change', 'update:modelValue'])

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  checkStrictly: {
    type: Boolean,
    default: true
  }
})

const defaultExpandedNodes = ref([])

const category_id = ref(),
  categoryLists = ref([]),
  treeSelectProps = {
    label: 'name',
    children: 'children',
    isLeaf: 'isLeaf'
  }

// 监听外部 modelValue 变化，同步到组件内部
watch(() => props.modelValue, (val) => {
  if (val) {
    nextTick(() => {
      category_id.value = val
    })
  }
})

async function treeSelect(e, node) {
  const data = {
    code: e.id,
    defaultExpandedNodes: getParentNodes(node)
  }
  emit('update:modelValue', e.id)
  emit('change', data)
}

// 递归获取选中节点以及所有父节点
function getParentNodes(node) {
  let arr = [node.data.value]
  while (node.parent) {
    if (node.parent.data.value) {
      arr.unshift(node.parent.data.value)
    }
    node = node.parent
  }
  return arr
}

async function searchCategory(query) {
  await getData(query)
}

async function getData(name) {
  const params = {}
  if (name) {
    params.name = name
  }
  params.level = name ? undefined : 0
  const { result } = await categoryList(params)
  if (result) {
    categoryLists.value = result.data.rows.map((item) => ({
      ...item,
      value: item.id,
      isLeaf: false,
      level: result.data.level
    }))
  }
}

async function load(node, resolve) {
  if (node.isLeaf) {
    return resolve([])
  }
  const { result } = await categoryList({
    id: node.key,
    level: node.level
  })
  if (result) {
    resolve(
      result.data.rows.map((item) => ({
        ...item,
        value: item.id,
        isLeaf: node.level >= 2
      }))
    )
  } else {
    resolve([])
  }
}

function focus() {
  if (!unref(categoryLists).length) {
    getData()
  }
}

function clearValue() {
  category_id.value = undefined
  defaultExpandedNodes.value = []
}

function clear() {
  clearValue()
  emit('update:modelValue', '')
  emit('change', {})
}

function setValue(value) {
  category_id.value = value[value.length - 1]
  defaultExpandedNodes.value = value
}

defineExpose({
  setValue,
  clearValue
})
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
}
</style>
